import styles from './index.module.css'

import React from 'react'

import { Select, Text } from 'components/ds'

export type SearchTypeOption<T = string> = {
  value: T
  label: string
}

type Props<T = string> = {
  value: T
  onChange: (_value: T) => void
  options: SearchTypeOption<T>[]
}

const SearchTypeSelector = <T extends string>({
  value,
  onChange,
  options,
}: Props<T>) => {
  const hasMultipleOptions = options.length > 1
  const currentOption = options.find(option => option.value === value)
  const displayLabel = currentOption?.label || value

  return (
    <Select.Root
      value={value}
      onValueChange={onChange}
      disabled={!hasMultipleOptions}
    >
      <Select.Trigger
        placeholder={displayLabel}
        variant="soft"
        className={styles.searchTypeSelector}
        data-testid="search-type-selector"
        style={{
          minWidth: '117px',
          cursor: hasMultipleOptions ? 'pointer' : 'default',
        }}
      />
      <Select.Content
        position="popper"
        side="bottom"
        align="start"
        sideOffset={4}
      >
        {options.map(option => (
          <Select.Item key={option.value} value={option.value}>
            <Text size="2" weight="medium">
              {option.label}
            </Text>
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}

export default SearchTypeSelector
